export default [
    {
      path: '/admin/daily-closeouts',
      name: 'daily-closeout',
      meta: { requiresAuth: true },
      component: () => import('@/pages/credit-operation/daily-closeout/index.vue')
    },
    {
      path: '/admin/daily-closeouts/create',
      name: 'daily-closeout-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/credit-operation/daily-closeout/create.vue')
    }
  ]
